import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Toastmessage from './components/Toast';
import { authApi } from './api/api';
import { logout } from './features/auth/AuthSlice';

const ProtectedRoute = ({ children, requiredSlug }) => {
  const token = useSelector((state) => state.auth.token);
  const userID = useSelector((state) => state.auth.id);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [apiResponse, setApiResponse] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAccess();
  }, [requiredSlug]);

  const transformResponse = (response) => {
    const actions = {
      list: false,
      add: false,
      edit: false,
      view: false,
      delete: false,
      addmember: false, 
      viewmember: false  
    };

    response.data.permissions.forEach((perm) => {
      const action = perm.name.toLowerCase();
      if (actions.hasOwnProperty(action)) {
        actions[action] = true;
      }
    });

    return {
      success: response.success,
      message: response.message,
      data: {
        ...response.data,
        actions
      }
    };
  };

  const fetchAccess = async () => {
    // Reset apiResponse to null before fetching new data
    setApiResponse(null);
    setLoading(true);

    const input_token = userID + 'ACCESS';
    const apiUrl = 'check_have_access';

    const dataInput = {
      login_user_id: userID,
      module_slug: requiredSlug,
    };

    try {
      const data = await authApi(input_token, dataInput, apiUrl, token);

      if (data && data.success) {
        const transformedResponse = transformResponse(data);
        setApiResponse(transformedResponse);
      } else if (data && data.message === 'Token has expired') {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/home');
      } else if (data === undefined) {
        await Toastmessage('No response from server', false);
      } else {
        await Toastmessage(data?.message || 'An error occurred', false);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      if (error.response && error.response.status === 401) {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else {
        await Toastmessage('Something went wrong', false);
      }
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!apiResponse?.success) {
    Toastmessage(`You do not have permission to access ${requiredSlug} page`, false);
    return <Navigate to="/home" />;
  }

  return apiResponse.success ? React.cloneElement(children, { apiResponse }) : null;
};

export default ProtectedRoute;
